import Cookies from "js-cookie";
import React, { useContext, useEffect, useState } from "react";
import { AxiosCustomGet } from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import SwalToast from "../../../components/helpers/SwalToast";
import httpclient from "../../../components/httpclient";
import Title from "../../../components/common/Title/Title";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import IsEmpty from "../../../components/helpers/IsEmpty";
import { Modal, Button, Input } from "antd";
import "antd/dist/antd.css";
import "./styles.css";
import CustomTable from "../../../components/common/Table/CustomTable";
import { PermissionContext } from "../../../components/context/PermissionContext";
import Swal from "sweetalert2";
import {
  AuthorizationList,
  CanAccess,
} from "../../../components/template/authorization/Authorization";
import { initFilterInput, renderColumns, statusItems } from "./constans";
import { Form } from "react-bootstrap";
import Select from "react-select";

const AppraiserList = () => {
  const myPermissions = useContext(PermissionContext);
  const [id, setId] = useState();
  const [appraiserName, setAppraiserName] = useState("");
  const [phone, setPhone] = useState("");
  const [status, setStatus] = useState(false);
  const [records, setRecords] = useState();
  const [modalAdd, setModalAdd] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tablePagination, setTablePagination] = useState({});
  const [filterInput, setFilterInput] = useState(initFilterInput);

  useEffect(() => {
    getData();
  }, [filterInput]);

  const handleTableChange = (pagination) => {
    setFilterInput((prev) => ({
      ...prev,
      page: pagination.current,
      pageSize: parseInt(pagination.pageSize),
    }));
  };

  const handleSubmit = () => {
    setSubmitting(true);

    let data = {
      id: id,
      name: appraiserName,
      phone_number: phone,
      status: status ? "active" : "inactive",
    };

    console.log(data);

    if (IsEmpty(id)) {
      let url = `${process.env.REACT_APP_BASE_API_URL}appraiser`;
      httpclient
        .POST(url, data)
        .then((response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          setModalAdd(false);
          getData();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    } else {
      console.log("edit");
      let url = `${process.env.REACT_APP_BASE_API_URL}appraiser`;
      httpclient
        .POST(url, data)
        .then((response) => {
          SwalToast.fire({
            icon: "success",
            title: response.data.message,
          });
          setModalAdd(false);
          getData();
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data.error);
            SwalToast.fire({
              icon: "error",
              title: error.response.data.error.message,
            });
          } else {
            console.log(error);
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        })
        .finally(() => {
          setSubmitting(false);
        });
    }
  };

  const handleDelete = (record) => {
    setSubmitting(true);
    let url = `${process.env.REACT_APP_BASE_API_URL}appraiser/${record.id}`;

    Swal.fire({
      title: "Hapus Data",
      text: "Apakah anda yakin ingin menghapus outlet " + record.name,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Hapus",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        httpclient
          .DELETE(url)
          .then((response) => {
            SwalToast.fire({
              icon: "success",
              title: response.data.message,
            });
            getData();
            setSubmitting(false);
          })
          .catch((error) => {
            console.log(error);
            if (error.response) {
              SwalToast.fire({
                icon: "error",
                title: error.response.data.error.message,
              });
            } else {
              SwalToast.fire({
                icon: "error",
                title: "Whoops, something went wrong",
              });
              setSubmitting(false);
            }
          });
      }
    });
  };

  const handleEdit = (record) => {
    console.log(record);
    setModalAdd(true);
    const { id, name, phone_number, status } = record;
    setAppraiserName(name);
    setPhone(phone_number);
    setStatus(status == "active" ? true : false);
    setId(id);
  };

  const handleCloseModal = () => {
    setModalAdd(false);
    setAppraiserName("");
    setPhone("");
    setStatus("");
    setId();
  };

  const getData = () => {
    setLoading(true);
    let params = {
      search: filterInput.search,
      status: filterInput.status,
      page: filterInput.page,
      size: filterInput.pageSize,
    };
    let url = `${process.env.REACT_APP_BASE_API_URL}appraiser`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        params
      ),
      (response) => {
        setLoading(false);
        console.log(response);

        setRecords(response.data.data.items);
        setTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      },
      (error) => {
        setLoading(false);
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: error.response.data,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const searchData = (name) => {
    console.log(name);
  };

  const handleFilter = (e) => {
    const { value, name } = e.target;
    if (e.key === "Enter" || e.keyCode === 13) {
      setFilterInput((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleChangeStatus = (e) => {
    console.log(e);
    setFilterInput((prev) => ({
      ...prev,
      status: e.value,
    }));
  };

  return (
    <>
      <div>
        <div className="px-3">
          <div className="py-4 d-flex flex-column" style={{ fontSize: "13px" }}>
            <Title text={"Juru Taksir"} />
            <Breadcrumb current={"Daftar Juru Taksir"} />
          </div>
          <div className="d-flex pt-3 px-0">
            <div className="d-flex col-6 px-0">
              <div className="col-6">
                Nama Juru Taksir :
                <input
                  type="text"
                  className="form-control form-control-lg border-97A0AE"
                  placeholder="Cari Nama"
                  name="search"
                  onKeyDown={handleFilter}
                  // value={filterInput.search}
                  onChange={handleFilter}
                />
              </div>
              <div className="col-6">
                Status :
                <Select
                  name="status"
                  onChange={handleChangeStatus}
                  options={statusItems}
                  defaultValue={statusItems[0]}
                />
              </div>
            </div>

            <CanAccess
              role={AuthorizationList.create_appraiser}
              yes={
                <div className="ml-auto" onClick={() => setModalAdd(true)}>
                  <button className="ml-3 btn border-438EBC bgc-2C465C text-white font-weight-semi-bold">
                    + Tambah Juru Taksir
                  </button>
                </div>
              }
            />
          </div>
          <div style={{ marginTop: 24 }}>
            <CustomTable
              columns={renderColumns(handleEdit, handleDelete)}
              data={records}
              loading={loading}
              handleTableChange={handleTableChange}
              pagination={tablePagination}
            />
          </div>
        </div>
      </div>

      <Modal
        className="modal-add"
        centered
        title={id ? "Ubah Juru Taksir" : "Tambah Juru Taksir"}
        visible={modalAdd}
        onOk={handleSubmit}
        onCancel={handleCloseModal}
        footer={[
          <Button
            onClick={handleCloseModal}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#000",
              background: "#FFFFFF",
            }}
          >
            Kembali
          </Button>,
          <Button
            type="submit"
            disabled={submitting}
            onClick={handleSubmit}
            style={{
              border: "0.75px solid #DCDCDC",
              borderRadius: 6,
              width: 120,
              height: 36,
              color: "#fff",
              background: "#2C465C",
            }}
          >
            Simpan
          </Button>,
        ]}
      >
        <div style={{ display: "flex", marginTop: 24 }}>
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Nama Juru Taksir :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="Nama Juru Taksir"
              value={appraiserName}
              onChange={(e) => setAppraiserName(e.target.value)}
            />
          </div>
        </div>
        <div style={{ display: "flex", marginTop: 12 }}>
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>No. Telepon :</div>
          </div>
          <div style={{ flex: 2 }}>
            <Input
              style={{ height: 36 }}
              required
              type="text"
              className="form-control border-DCDCDC text-input"
              placeholder="No. Telepon"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
        </div>
        <div style={{ display: "flex", marginTop: 12 }}>
          <div style={{ flex: 1 }}>
            <div style={{ color: "#A6A6A6" }}>Status Akun :</div>
          </div>
          <div style={{ flex: 2, height: 40 }}>
            <Form.Check
              id="custom-switch"
              checked={status}
              style={{
                color: status ? "#6AC268" : "#F23434",
                fontWeight: 700,
                zIndex: 0,
              }}
              type="switch"
              label={status ? "Aktif" : "Non Aktif"}
              onChange={() => setStatus(!status)}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

export default AppraiserList;
